import css from './PasswordPolicy.module.css';

const PasswordPolicy = () => {
  return (
    <div className={css.policy}>
      <p>Your password must:</p>
      <ul>
        <li>Be at least 8 characters long</li>
        <li>Contain a lowercase letter</li>
        <li>Contain an uppercase letter</li>
        <li>Contain a number</li>
        <li>Contain a special character (!@#$%^&*)</li>
      </ul>
    </div>
  );
};

export default PasswordPolicy;
